import React from "react";

export default function SimpleEventCard({ image, title, location, compact = false }) {
  return (
    <div className={`group flex h-full w-full min-w-0 flex-col ${compact ? "text-left" : "text-center"}`}>
      {/* Poster */}
      <div
        className={`relative aspect-[9/16] w-full overflow-hidden ring-[0.5px] ring-white/10 transition duration-300 group-hover:ring-white/25 ${
          compact ? "rounded-lg" : "rounded-xl"
        }`}
      >
        <img
          src={image}
          alt={title || "Event"}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
      </div>

      {/* Title + venue — now visible on mobile too */}
      {title && (
        <h3
          className={`font-semibold leading-snug text-white ${
            compact
              ? "mt-1.5 truncate text-[11px] sm:text-[12px]"
              : "mt-3 line-clamp-2 text-[15px] md:mt-3.5 md:text-[18px]"
          }`}
        >
          {title}
        </h3>
      )}

      <div className="mt-auto w-full">
        {location && (
          <p
            className={`font-normal text-white/55 ${
              compact
                ? "mt-0.5 truncate text-[10px] sm:text-[11px]"
                : "mt-1 text-[12px] md:mt-1.5 md:text-[14px]"
            }`}
          >
            {location}
          </p>
        )}

        {/* CTA — brand blue, subtle hover lift (span avoids nested <button> inside <Link>) */}
        <span
          className={`block w-full rounded-md bg-brand-blue text-center font-semibold text-white transition-colors duration-200 group-hover:bg-brand-blue-hover ${
            compact
              ? "mt-1.5 px-1 py-1 text-[10px] sm:text-[11px]"
              : "mt-3 rounded-lg py-2.5 text-[13px] md:mt-3.5 md:text-[15px]"
          }`}
        >
          Find Tickets
        </span>
      </div>
    </div>
  );
}
